import React, { useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import TwoFa from "../../elements/twoFa/TwoFa";
import DialogModal from "../../elements/dialogModal/DialogModal";
import { TextField } from "@material-ui/core";
import DefaultButton from "../../styles/materialButtonStyle";

import { StyledBlockAction, StyledBlockLabel, StyledFormBlock, StyledInputBlock } from "../../styles/styledTabsForm";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { StyledDialogAction } from "../../styles/styledDialog";
import { useTranslation } from "react-i18next";

const ProcessingBalanceRefilingForm = ({ payment, notification, setNotification, type, fetchAction }) => {
  const { t } = useTranslation("paymentsPage");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [actionType, setActionType] = useState(null);

  const [submitData, setSubmitData] = useState({
    status: null,
    processedAmount: null
  });

  const handleSave = async (event) => {
    event.preventDefault();

    if (actionType === "save") {
      let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

      if (check2Fa.error) {
        setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
        return;
      }
    }

    axios.put("/api/" + type + "/" + payment.id, submitData, userAuthenticationConfig(false)).then(response => {
      if (response.status === 200) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("processingBalanceRefiling.success") });
        fetchAction();
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const handleCancel = (event) => {
    event.preventDefault();
    setSubmitData({
      ...submitData,
      status: "FAIL",
      processedAmount: "0"
    });
    setActionType("cancel");
    setOpen(true);
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("processingBalanceRefiling.confirmTitle")}
        content={
          actionType === "save"
            ? <TwoFa handleSubmit={handleSave} error={error} />
            : (
              <form onSubmit={handleSave}>
                <p style={{ marginBottom: 20 }}>
                  {t("processingBalanceRefiling.cancelQuestion")}<br />
                  <b>ID: {payment.id}</b>
                </p>
                <StyledDialogAction col="2">
                  <DefaultButton
                    onClick={() => setOpen(false)}
                    color="transparent"
                  >
                    {t("processingBalanceRefiling.no")}
                  </DefaultButton>
                  <DefaultButton color="danger" type="submit">
                    {t("processingBalanceRefiling.cancelTransaction")}
                  </DefaultButton>
                </StyledDialogAction>
              </form>
            )
        }
      />

      <form
        onSubmit={event => {
          event.preventDefault();
          setSubmitData({
            ...submitData,
            status: "PROCESSED",
            processedAmount: event.target.processedAmount.value
          });
          setActionType("save");
          setOpen(true);
        }}
      >
        <StyledFormBlock>
          <StyledBlockLabel>
            {t("processingBalanceRefiling.amountConfirmation")}
          </StyledBlockLabel>
          <StyledInputBlock>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("processingBalanceRefiling.amount")}
              id="processedAmount"
              type="text"
              name="processedAmount"
              defaultValue={payment.amount}
            />
          </StyledInputBlock>
          <div className="clear-column" />
        </StyledFormBlock>
        <StyledFormBlock>
          <div className="clear-column" />
          <StyledBlockAction>
            <DefaultButton
              color="success"
              type="submit"
            >
              {t("processingBalanceRefiling.save")}
            </DefaultButton>
          </StyledBlockAction>
          <div className="clear-column" />
        </StyledFormBlock>
        <StyledFormBlock>
          <div className="clear-column" />
          <StyledBlockAction>
            <DefaultButton
              color="danger"
              type="button"
              onClick={handleCancel}
            >
              {t("processingBalanceRefiling.cancel")}
            </DefaultButton>
          </StyledBlockAction>
          <div className="clear-column" />
        </StyledFormBlock>
      </form>
    </>
  );
};

export default ProcessingBalanceRefilingForm;